import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=834c4d70&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=834c4d70&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834c4d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('834c4d70')) {
      api.createRecord('834c4d70', component.options)
    } else {
      api.reload('834c4d70', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=834c4d70&scoped=true", function () {
      api.rerender('834c4d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Accordion.vue"
export default component.exports